import React from "react";
import "./whatIsIncluded.scss";
import bootCampCoverPng from "../../assets/bootcamps.png";
import prenatalPng from "../../assets/prenatal.png";
import consultationPng from "../../assets/consultation.png";
import groupPng from "../../assets/group.png";
import survivalPng from "../../assets/survival.png";

const WhatIsIncluded = ({
  joinTheClubHandle,
  mainDescription = 'with your annual membership',
}: {
  joinTheClubHandle: () => void;
  mainDescription?: string
}) => (
  <div className="preLoginIncluded">
    <h2 className="heading2">Save over $1500</h2>
    <p className="mainDescription">{mainDescription}</p>

    <div className="preLoginIncludedList">
      <div className="preLoginIncludedJump">
        <h2 className="heading3">What’s included?</h2>
        <p className="description">
            From pre-baby bootcamp to 1:1 consultations, your annual membership covers it all.
        </p>
        <button
          className="w-auto btn-small teal-btn-small"
          onClick={joinTheClubHandle}
        >
            Join Now
        </button>
      </div>

      {[
        {
          id: 0,
          cover: consultationPng,
          title: "Private Consultations",
          description: "1:1 consultations covers everything from feeding and sleep to mental health and more; includes 1 virtual feeding consultation with a nurse and IBCLC and two 30-minute sessions with a nurse",
          price: "575",
        },
        {
          id: 1,
          cover: bootCampCoverPng,
          title: "Bootcamps",
          description:
            "Pre Baby Bootcamp (for the first time expecting parent), Veteran Bootcamp (for the experienced parent), and Grandparent Bootcamp (for the grandparent who wants to brush up)",
          price: "650",
        },
        {
          id: 2,
          cover: prenatalPng,
          title: "Prenatal & Postpartum Classes",
          description:
            "Includes Labor & Delivery Prep, Newborn Essentials, Breastfeeding Basics, and Infant & Child CPR with First Aid Classes",
          price: "500",
        },
        {
          id: 3,
          cover: survivalPng,
          title: "Peer Support Groups",
          description:
            "New Mom Group (for the first time expecting parent), Veteran Group (for the experienced parent), Working Group (for preparing to return to work), and Dad’s Group",
          price: "995",
        },
        {
          id: 4,
          cover: groupPng,
          title: "Group Consultations",
          description:
            "Discuss feeding, sleep, developmental milestone, transitions, mental health, pelvic health, and more with a group of parents in a similar stage",
          price: "500",
        },
      ].map((card) => (
        <div className="preLoginIncludedCard" key={card.id}>
          <img src={card.cover} alt="" />
          <div className="preLoginIncludedContent">
            <div className="preLoginIncludedBadge">Included</div>
            <p className="preLoginIncludedTitle">{card.title}</p>
            <p className="preLoginIncludedDescription">{card.description}</p>
            <p className="preLoginIncludedPrice">
              Non Member price <span>${card.price}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default WhatIsIncluded;
